window.addEventListener('DOMContentLoaded', () => {
	const header = document.querySelector('header')
	const hamburger = header?.querySelector('.hamburger')
	let previousScrollTop = 0

	window.addEventListener('scroll', e => {
		let currentScrollTop = window.scrollY

		if (previousScrollTop - currentScrollTop < 0 && currentScrollTop > 150) {
			header.classList.add('scrolled-down')
			hamburger.classList.remove('open')
		} else {
			header.classList.remove('scrolled-down')
		}

		if (currentScrollTop > 50) {
			header.classList.add('add-bg-color')
		} else {
			header.classList.remove('add-bg-color')
		}

		previousScrollTop = currentScrollTop
	})

	hamburger.addEventListener('click', e => {
		hamburger.classList.toggle('open')
		if (hamburger.classList.contains('open')) {
			document.body.style.overflow = 'hidden'
		} else {
			document.body.style.overflow = 'auto'
		}
	})

	window.addEventListener('click', e => {
		if (!e.target.closest('.menu-item') && !e.target.closest('.hamburger')) {
			document.body.style.overflow = 'auto'
			hamburger.classList.remove('open')
		}
	})

	// Mobile menu accordions
	const parents = header.querySelectorAll(
		'nav > .wrapper > .menu-items > .menu-item.menu-item-has-children'
	)
	const children = header.querySelectorAll(
		'nav > .wrapper > .menu-items > .menu-item.menu-item-has-children > ul'
	)

	parents.forEach(parent => {
		parent.addEventListener('click', () => {
			parent.classList.toggle('open')
		})
	})
	children.forEach(child => {
		child.setAttribute('style', `--height: ${child.scrollHeight}px;`)
	})

	window.addEventListener('resize', () => {
		children.forEach(child => {
			child.setAttribute('style', `--height: auto;`)
			child.setAttribute('style', `--height: ${child.scrollHeight}px;`)
		})
	})
})
